import { useNavigate } from 'react-router-dom';
import { CircleAlert } from 'lucide-react';
import { Layout } from '../components/Layout';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { colors } from '../constants/colors';

export function NotFoundPage() {
  useDocumentTitle('Not Found');
  const navigate = useNavigate();

  return (
    <Layout>
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.iconWrapper}>
            <CircleAlert size={48} color={colors.gray[400]} />
          </div>
          <h1 style={styles.code}>404</h1>
          <p style={styles.title}>Page not found</p>
          <p style={styles.subtitle}>
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div style={styles.actions}>
            <button onClick={() => navigate(-1)} style={styles.secondaryButton}>
              Go Back
            </button>
            <button onClick={() => navigate('/')} style={styles.primaryButton}>
              Browse Shows
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 140px)',
    padding: '24px',
  },
  card: {
    textAlign: 'center',
    backgroundColor: colors.white,
    borderRadius: '16px',
    border: `1px solid ${colors.gray[300]}`,
    padding: '48px 40px',
    maxWidth: '440px',
    width: '100%',
  },
  iconWrapper: {
    marginBottom: '8px',
  },
  code: {
    fontSize: '72px',
    fontWeight: 800,
    color: colors.ink.black,
    margin: '0 0 8px 0',
    letterSpacing: '-2px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
    color: colors.ink.black,
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: '15px',
    color: colors.gray[600],
    lineHeight: 1.5,
    margin: '0 0 32px 0',
  },
  actions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
  },
  primaryButton: {
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: 600,
    color: colors.white,
    backgroundColor: colors.brand.blue,
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  secondaryButton: {
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: 600,
    color: colors.brand.blue,
    backgroundColor: colors.brand.blue15,
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
  },
};
